if(typeof BSS_B2B != undefined) {
  window.addEventListener("cart_changed", () => {
    setTimeout(() => {
      let storeData = JSON.parse($("#bss-b2b-store-data").html());
      BSS_B2B.makeChangesAfterClickAjaxCart(500)
      BSS_B2B.cart.fixer(storeData, null, false);
      BSS_B2B.handleCartCheckoutBtn(storeData);
    }, 500);
  });

  if(window.location.pathname.includes("/products/")) {
    const loop = setInterval(() =>{
      const inputVariant = document.querySelector("product-form input[bss-b2b-qb-change-variant-added-event]");

      if (inputVariant) {
        clearInterval(loop);
        const mutationObserver = new MutationObserver((recordList, observe) => {
          $(".bss-b2b-cart-item-qty-table:not([bss-b2b-qb-featured-product-id] .bss-b2b-cart-item-qty-table)").remove();
          BSS_B2B.qb.generateTableOnProductPage();
        });
        mutationObserver.observe(inputVariant, { attributes: true });
      }
    }, 100);

    setTimeout(() =>{
      clearInterval(loop);
    }, 10000)
  }
  

BSS_B2B.customTriggerCheckoutBtn = function(checkoutBtn){
    window.location.href = "/checkout";
  }

  if(window.location.pathname.includes("/products/")) {
    setTimeout(() =>{
      const product = document.querySelector('gp-product form[action="/cart/add"]');
      const productId = product.querySelector('input[name="product-id"]')?.value;
      const variantId = product.querySelector('input[name="id"]')?.value;
          
      if (productId && variantId) {
          const priceElement = product.querySelectorAll("gp-product-price");
          priceElement.forEach((item) => {
            item?.setAttribute("bss-b2b-product-id", productId);
            item?.setAttribute("bss-b2b-product-price", "");
            item?.setAttribute("bss-b2b-variant-id", variantId);
            item?.setAttribute("bss-b2b-variant-price", "");
            item?.setAttribute("bss-b2b-featured-product", "");
          })
       
      }
      BSS_B2B.cp.changeProductPrice(JSON.parse($('#bss-b2b-store-data').html()), false, false, false);
  }, 500)
  }
 
}


window.addEventListener('DOMContentLoaded', () => {
 setTimeout(() => {
    const productItems = document.querySelectorAll('.boost-sd__filter-block .boost-sd__product-item');
    if (!productItems.length) return;

    productItems.forEach(item => {
      const productId = item.getAttribute('data-product-id');
      const productPrice = item.querySelector('.boost-sd__product-price-content');

      if (productPrice && productId) {
        productPrice.setAttribute('bss-b2b-product-id', productId);
        productPrice.setAttribute('bss-b2b-product-price', '');
      }
    });
  }, 1500);
});

window.addEventListener('load', () => {
  setTimeout(() => {
    const subTotalElements = document.querySelectorAll('.docapp-right .money');
    subTotalElements.forEach(el => {
      el.setAttribute('bss-b2b-cart-total-price', '');
    });
    BSS_B2B.cart.fixer(BSS_B2B.shopData,null, false)
  }, 1500);
});


    
